module["exports"] = [
  "#####",
  "#####-####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/address/postcode.js
// module id = 991
// module chunks = 0